import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import Breadcrumbs from "../breadcrumbs/index";
import BreadcrumbCollection from "../../collections/breadcrumbs";
import ViewHeaderActions from "../view-header/actions";
import AdminBehavior from "../../behaviors/admin";
import ContentBehavior from "../../behaviors/content";

import "../../../../sass/main.scss";

// temporarily handle title setting to reset the action buttons.
const channel = Radio.channel("global");

const DEFAULTS = {
  el: "main",
  template: false,
  regions: {
    breadcrumbs: ".view-header-breadcrumbs",
    actions: ".view-header-actions",
    content: "#content",
  },
};

class Main extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  behaviors() {
    return [
      { behaviorClass: AdminBehavior },
      { behaviorClass: ContentBehavior },
    ];
  }

  // TODO this method should become onBeforeShow when its parent is no longer
  // instantiated directly.
  initialize() {
    // temporary - used to reset the existing actions buttons when a new
    // report is requested.
    this.listenTo(channel, "set:title", this._onSetTitle);

    this.breadcrumbs.show(
      new Breadcrumbs({
        collection: new BreadcrumbCollection(),
      })
    );

    this.actions.show(new ViewHeaderActions());
  }

  _onSetTitle() {
    this.actions.show(new ViewHeaderActions());
  }
}

export { Main as default };
